import css from 'styled-jsx/css';
import { colors } from '../../../../themes';

export const wrapper = css`
  .features {
    list-style: none;
    margin: 0;
    padding: 3px 0 0;
    white-space: nowrap;
  }
`;

export const item = css`
  li {
    border-left: 1px solid ${colors.grayItems};
    display: inline-block;
    padding: 0 10px;
    text-align: left;
  }

  li:first-child {
    border-left: none;
    padding-left: 0;
  }

  li:last-child {
    padding-right: 0;
  }

  .name {
    display: block;
    font-size: 0.65em; /* 12/16 */
  }

  .value :global(.measure) {
    font-size: 0.75em; /* 12/16 */
  }

  .description-container {
    white-space: normal;
  }

  .description {
    font-size: 0.78em;
  }

  :global(.rtl) li {
    border-left: 0;
    border-right: 1px solid ${colors.grayItems};
    text-align: right;
  }

  :global(.rtl) li:first-child {
    border-right: none;
    padding-right: 0;
    padding-left: 10px;
  }

  :global(.rtl) li:last-child {
    padding-left: 0;
    padding-right: 10px;
  }
`;



// WEBPACK FOOTER //
// ./app/components/mobile/Features/shared/styles.js